module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedi1",
    attrs: {
      "id": "dedi"
    }
  }, [_c('em', [_vm._v("This book is dedicated to my wife, Donna")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_c('em', [_vm._v("Her patience with me is unfathomable and")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_c('em', [_vm._v("her contributions to my life are incalculable")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_c('em', [_vm._v("I love you!")]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c261772","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedi.vue
// module id = 72
// module chunks = 0